import { render, staticRenderFns } from "./BannerTab.vue?vue&type=template&id=6ef9020c"
import script from "./BannerTab.vue?vue&type=script&lang=js"
export * from "./BannerTab.vue?vue&type=script&lang=js"
import style0 from "./BannerTab.vue?vue&type=style&index=0&id=6ef9020c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports